import React, { useEffect, useState } from 'react';
import { ControlRow2, CustomInput, ThreeControlRow } from './costing-page1';
import { Col, Panel, Row } from 'rsuite';
import axios from 'axios';
import globalIP from '@/GlobelIP';
import { Width } from '@rsuite/icons';
import { ColumnGroup } from 'primereact/columngroup';

export const BottomLeftSection = React.memo(
  ({
    handleFieldDataValue,
    fieldData,
    setReload,
    setReload2,
    showTables,
    updatingCalc,

    setCostingheads,
    costingheads,
    handleReload,
    handleFieldUpdate
  }) => {
    // Fetch data from API on mount

    return (
      <Col xs={24}>
        <Panel
          style={{
            boxShadow: '0px 0px 4px -1px grey',
            borderRadius: '6px',
            marginBottom: '10px',
            width: '99.8%',
            marginLeft: '-15px'
          }}
        >
          <Row gutter={20}>
            <Col xs={12}>
              <ControlRow2
                label="OverAllCost"
                control={
                  <CustomInput
                    id="custinputno"
                    step={null}
                    placeholder="0.00"
                    name="overAllCost"
                    value={(+fieldData?.overallcost).toFixed(2)}
                  />
                }
              />
            </Col>
            {/* <Col xs={12} style={{ marginTop: '10px' }}>
              <ThreeControlRow
                label="GST %"
                control={
                  <CustomInput 
                  id='custinputno'
                    step={null}
                    name="gstper"
                    value={fieldData.gstper || ''}
                    onChange={value => {
                      const result = (+fieldData.overallcost * +value) / 100;
                      handleFieldDataValue('gstper', value);
                      handleFieldDataValue('gstcost', result.toFixed(2));
                      handleReload();
                    }}
                  />
                }
                control2={
                  <CustomInput 
                  id='custinputno'
                    step={null}
                    name="gstcost"
                    value={fieldData.gstcost || ''}
                    onChange={value => {
                      const percentage = (+value / +fieldData.overallcost) * 100;
                      handleFieldDataValue('gstcost', value);
                      handleFieldDataValue('gstper', percentage.toFixed(2));
                      handleReload();
                    }}
                    onFocus={() => {
                      handleFieldUpdate("GST", true);
                    }}
                    onBlur={() =>
                      handleFieldUpdate("GST", false)
                    }
                  />
                }
              />
            </Col> */}
          </Row>
          <Row>
            <Col xs={12} style={{ marginTop: '10px' }}>
              <ThreeControlRow
                label="Testing %"
                control={
                  <CustomInput
                    id="custinputno"
                    step={null}
                    name="testingper"
                    value={
                      updatingCalc.Testingper
                        ? (+fieldData.testingper)
                        : (+fieldData.testingper).toFixed(2)
                    } 
                    onChange={value => {
                      console.log('fieldData.testingper')
                      console.log(fieldData.testingper)
                      const result = (+fieldData.overallcost * +value) / 100;
                      handleFieldDataValue('testingper', value);
                      handleFieldDataValue('testingcost', result.toFixed(2));
                      handleReload();
                    }}
                    onFocus={() => handleFieldUpdate('Testingper', true)}
                    onBlur={() => handleFieldUpdate('Testingper', false)}
                  />
                }
                control2={
                  <CustomInput
                    id="custinputno"
                    step={null}
                    name="testingcost"
                    value={
                      updatingCalc.Testingcost
                        ? fieldData.testingcost
                        : (+fieldData.testingcost).toFixed(2)
                    }
                    onChange={value => {
                      // const percentage = (+value / +fieldData.overallcost) * 100;
                      handleFieldDataValue('testingcost', value);
                      // handleFieldDataValue('testingper', percentage.toFixed(2));
                      handleReload();
                    }}
                    onFocus={() => handleFieldUpdate('Testingcost', true)}
                    onBlur={() => handleFieldUpdate('Testingcost', false)}
                  />
                }
              />
            </Col>
            <Col xs={12} style={{ marginTop: '10px' }}>
              <ThreeControlRow
                label="OverHead %"
                control={
                  <CustomInput
                    id="custinputno"
                    step={null}
                    name="overheadper"
                    value={
                      updatingCalc.OverHeadper
                        ? fieldData.overheadper
                        : (+fieldData.overheadper).toFixed(2)
                    }
                    onChange={value => {
                      const result = (+fieldData.subtotalcost * +value) / 100;
                      handleFieldDataValue('overheadper', value);
                      handleFieldDataValue('overheadcost', result.toFixed(2));
                      handleReload();
                    }}
                    onFocus={() => handleFieldUpdate('OverHeadper', true)}
                    onBlur={() => handleFieldUpdate('OverHeadper', false)}
                  />
                }
                control2={
                  <CustomInput
                    id="custinputno"
                    step={null}
                    name="overheadcost"
                    value={
                      updatingCalc.OverHeadcost
                        ? fieldData.overheadcost
                        : (+fieldData.overheadcost).toFixed(2)
                    }
                    onChange={value => {
                      const percentage = (+value / +fieldData.subtotalcost) * 100;
                      handleFieldDataValue('overheadcost', value);
                      handleFieldDataValue('overheadper', percentage.toFixed(2));
                      handleReload();
                    }}
                    onFocus={() => handleFieldUpdate('OverHeadcost', true)}
                    onBlur={() => handleFieldUpdate('OverHeadcost', false)}
                  />
                }
              />
            </Col>
            <Col xs={12} style={{ marginTop: '10px' }}>
              <ThreeControlRow
                label="Laison %"
                control={
                  <CustomInput
                    id="custinputno"
                    step={null}
                    name="laisonper"
                    value={
                      updatingCalc.Laisonper
                        ? fieldData.laisonper
                        : (+fieldData.laisonper).toFixed(2)
                    }
                    onChange={value => {
                      const result = (value * fieldData.overallcost) / 100;
                      handleFieldDataValue('laisonper', value);
                      handleFieldDataValue('laisoncost', result.toFixed(2));
                      handleReload();
                    }}
                    onFocus={() => handleFieldUpdate('Laisonper', true)}
                    onBlur={() => handleFieldUpdate('Laisonper', false)}
                  />
                }
                control2={
                  <CustomInput
                    id="custinputno"
                    step={null}
                    name="laisoncost"
                    value={
                      updatingCalc.Laisoncost
                        ? fieldData.laisoncost
                        : (+fieldData.laisoncost).toFixed(2)
                    }
                    onChange={value => {
                      const percentage = (value / +fieldData.overallcost) * 100;
                        console.log('laisoncost',value);
                      handleFieldDataValue('laisoncost', value);
                      handleFieldDataValue('laisonper', percentage.toFixed(2));
                      handleReload();
                    }}
                    onFocus={() => handleFieldUpdate('Laisoncost', true)}
                    onBlur={() => handleFieldUpdate('Laisoncost', false)}
                  />
                }
              />
            </Col>
            <Col xs={12} style={{ marginTop: '10px' }}>
              <ControlRow2
                label={<strong>Sub Total W/OH</strong>}
                control={
                  <CustomInput
                    id="custinputno2"
                    name="subtotalwohcost"
                    value={(+fieldData.subtotalwohcost).toFixed(2)}
                  />
                }
              />
            </Col>
            <Col xs={12} style={{ marginTop: '10px' }}>
              <ThreeControlRow
                label="Other %"
                control={
                  <CustomInput
                    id="custinputno"
                    step={null}
                    name="otherper"
                    value={
                      updatingCalc.Otherper
                        ? fieldData.otherper
                        : (+fieldData.otherper).toFixed(2)
                    }
                    onChange={value => {
                      const result = (+fieldData.overallcost * +value) / 100;
                      handleFieldDataValue('otherper', value);
                      handleFieldDataValue('othercost', result.toFixed(2));
                      handleReload();
                    }}
                    onFocus={() => handleFieldUpdate('Otherper', true)}
                    onBlur={() => handleFieldUpdate('Otherper', false)}
                  />
                }
                control2={
                  <CustomInput
                    id="custinputno"
                    step={null}
                    name="othercost"
                    value={
                      updatingCalc.Othercost
                        ? fieldData.othercost
                        : (+fieldData.othercost).toFixed(2)
                    }
                    onChange={value => {
                      const percentage = (+value / +fieldData.overallcost) * 100;
                      handleFieldDataValue('othercost', value);
                      handleFieldDataValue('otherper', percentage.toFixed(2));
                      handleReload();
                    }}
                    onFocus={() => handleFieldUpdate('Othercost', true)}
                    onBlur={() => handleFieldUpdate('Othercost', false)}
                  />
                }
              />
            </Col>
            <Col xs={12} style={{ marginTop: '10px' }}>
              <ThreeControlRow
                label="Misc %"
                control={
                  <CustomInput
                    id="custinputno"
                    step={null}
                    name="miscper"
                    value={
                      updatingCalc.Miscper ? fieldData.miscper : (+fieldData.miscper).toFixed(2)
                    }
                    onChange={value => {
                      const result = (+fieldData.subtotalwohcost * +value) / 100;
                      handleFieldDataValue('miscper', value);
                      handleFieldDataValue('misccost', result.toFixed(2));
                      handleReload();
                    }}
                    onFocus={() => handleFieldUpdate('Miscper', true)}
                    onBlur={() => handleFieldUpdate('Miscper', false)}
                  />
                }
                control2={
                  <CustomInput
                    id="custinputno"
                    step={null}
                    name="misccost"
                    value={
                      updatingCalc.Misccost
                        ? fieldData.misccost
                        : (+fieldData.misccost).toFixed(2)
                    }
                    onChange={value => {
                      const percentage = (+value / +fieldData.subtotalcost) * 100;
                      handleFieldDataValue('misccost', value);
                      handleFieldDataValue('miscper', percentage.toFixed(2));
                      handleReload();
                    }}
                    onFocus={() => handleFieldUpdate('Misccost', true)}
                    onBlur={() => handleFieldUpdate('Misccost', false)}
                  />
                }
              />
            </Col>
            <Col xs={12} style={{ marginTop: '10px' }}>
              <ControlRow2
                label={<strong>Sub Total</strong>}
                control={
                  <CustomInput id="custinputno2" value={(+fieldData?.subtotalcost).toFixed(2)} />
                }
              />
            </Col>
            <Col xs={12} style={{ marginTop: '10px' }}>
              <ThreeControlRow
                label="Shipping Cost"
                control={
                  <CustomInput
                    id="custinputno"
                    step={null}
                    name="miscper"
                    value={costingheads?.FOB || 0}
                    onChange={value => {
                      setCostingheads(prev => ({
                        ...prev,
                        FOB: +value
                      }));
                      handleReload();
                    }}
                  />
                }
                control2={
                  <CustomInput
                    id="custinputno"
                    step={null}
                    placeholder="0.00"
                    value={(+fieldData?.shippingcost).toFixed(2) || 0}
                    readOnly
                  />
                }
              />
            </Col>
          </Row>
        </Panel>
      </Col>
    );
  }
);
